import React from 'react';
import { useFormContext } from 'react-hook-form';
import ZHLPaymentDonutChart from '../PaymentDonutChart/PaymentDonutChart.js';
import { useLastValidAffordabilityValues } from './AffordabilityCalculator.utils.js';

function AffordabilityChart() {
  var form = useFormContext();
  var lastValidValues = useLastValidAffordabilityValues(form);
  var taxes = lastValidValues.calculations.affordability.affordabilityByDTI * (lastValidValues.fields.propertyTaxRate / 100) / 12;
  var insurance = lastValidValues.fields.annualHomeownersInsurance / 12;
  var chartDataProps = {
    monthlyPayment: lastValidValues.calculations.affordability.monthlyPayment,
    monthlyPI: lastValidValues.calculations.pi,
    monthlyPropertyTax: lastValidValues.fields.includeTaxesInsurance ? taxes : 0,
    monthlyHomeownersInsurance: lastValidValues.fields.includeTaxesInsurance ? insurance : 0,
    monthlyPMI: lastValidValues.fields.includePMI ? lastValidValues.calculations.pmi : 0,
    monthlyHOA: lastValidValues.fields.monthlyHOA
  };
  return /*#__PURE__*/React.createElement(ZHLPaymentDonutChart, chartDataProps);
}

export { AffordabilityChart as default };
